(() => {
	const normalizeSlideRoles = (el) => {
		el.querySelectorAll('li.brand-list__item').forEach((slide) => {
			if (slide.getAttribute('role') !== 'listitem') {
				slide.setAttribute('role', 'listitem')
			}

			if (slide.hasAttribute('aria-label')) {
				slide.removeAttribute('aria-label')
			}
		})
	}

	const initSlider = () => {
		const sections = document.querySelectorAll('.brand-list');

		sections.forEach((el) => {
			if (el.dataset.brandSliderInitialized === 'true') {
				normalizeSlideRoles(el)
				return
			}

			el.dataset.brandSliderInitialized = 'true'
			const speed1 = el.getAttribute('data-duration') * 1000;

			new Swiper(el, {
				slidesPerView: 2,
				autoplay: {
					delay: 0,
					disableOnInteraction: false,
				},
				allowTouchMove: false,
				loop: true,
				speed: speed1,
				breakpoints: {
					750: {
						slidesPerView: 3,
					},
					990: {
						slidesPerView: 4,
					},
					1200: {
						slidesPerView: 6,
					},
				},
				on: {
					init() {
						normalizeSlideRoles(el)
					},
					loopFix() {
						normalizeSlideRoles(el)
					},
					slideChange() {
						normalizeSlideRoles(el)
					},
				},
			})

			normalizeSlideRoles(el)
			window.setTimeout(() => normalizeSlideRoles(el), 0)
			window.setTimeout(() => normalizeSlideRoles(el), 500)

			const observer = new MutationObserver(() => normalizeSlideRoles(el))
			observer.observe(el, {
				attributes: true,
				childList: true,
				subtree: true,
				attributeFilter: ['role', 'aria-label', 'class'],
			})
		})
	}

	document.addEventListener('DOMContentLoaded', function () {
		initSlider()

		document.addEventListener('shopify:section:load', function () {
			initSlider()
		})
	})
})()
